export const LANGUAGE_DEFAULT = {
	label: 'Русский',
	value: 'ru-RU',
};